import { map } from "lodash";

const getLastSyncProjectFromV2Data = v2Data => (v2Data.uiState ? v2Data.uiState.LastSyncProject : null);

const getAllSyncProjectsFromV2Data = v2Data => {
  return v2Data && v2Data.syncData ? map(v2Data.syncData, d => d.lastProjectPath) : [];
};

export default {
  getLastSyncProjectFromV2Data,
  getAllSyncProjectsFromV2Data
};
